import React, { FC } from 'react';

import ReferralCTA from '../referral/ReferralCTA';
import TravelCreditsHero from '../static-pages/travel-credits/TravelCreditsHero';
import Heading from '../switchback/Heading/Heading';
import css from './ReferralTemplate.module.css';

export interface IBlockElement {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}
interface ITravelCreditsTemplateProps {
  contentBlocks: IBlockElement[];
}

const TravelCreditsTemplate: FC<ITravelCreditsTemplateProps> = ({ contentBlocks = [] }) => {
  const renderStaticSections = () => {
    return contentBlocks.map((block, idx) => {
      switch (block.type) {
        case 'split':
          // Hero section
          if (idx === 0 && Array.isArray(block.value?.left) && Array.isArray(block.value?.right)) {
            return (
              <TravelCreditsHero left={block.value.left} right={block.value.right} key={idx} />
            );
          }
          // more-ways-to-earn section
          if (
            idx === contentBlocks.length - 1 &&
            Array.isArray(block.value?.left) &&
            Array.isArray(block.value?.right)
          ) {
            return (
              <ReferralCTA
                left={block.value.left}
                right={block.value.right}
                key={idx}
                className={css.spacing}
                isTravelCredit
              />
            );
          }
          return null;
        case 'heading':
          return (
            <Heading key={idx} level={2} className={`h2 text-gray-800 mb-10 ${css.spacing}`}>
              {block.value}
            </Heading>
          );
      }
    });
  };
  return <main className="my-20">{renderStaticSections()}</main>;
};

export default TravelCreditsTemplate;
